<template>
  <div class="analytics-exchanges">
    <div class="container-wrapper bg--color-02">
      <div class="analytics-exchanges__container container-new">
        <div class="analytics-exchanges__info">
          <h5
            class="txt--bold txt--36px txt--44px--l txt--height-44px txt--height-58px--l txt--color-04 mb-16 mb-24--l"
          >
            {{ $t('business.analyticsExchanges.title') }}
          </h5>
          <p
            class="txt--weight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-03 mb-0"
            v-html="$t('business.analyticsExchanges.desc')"
          />
        </div>
        <div class="analytics-exchanges__image">
          <img
            src="@/assets/img/business/analytics-exchanges/graph.svg"
            width="100%"
            alt="graph icon"
          >
          <p class="analytics-exchanges__image-text mb-0">
            {{ $t('business.analyticsExchanges.imageDescription') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalyticsExchanges',
}
</script>

<style lang="scss" scoped>
.analytics-exchanges {
  &__container {
    display: grid;
    gap: toRem(16px);
    grid-template-areas: 'info' 'image';

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-areas: 'image info';
      gap: toRem(50px);
    }
  }

  &__info {
    grid-area: info;

    @include bp(m) {
      margin: auto 0;
    }
  }

  &__image {
    grid-area: image;
    display: flex;
    flex-direction: column;

    img {
      max-width: toRem(620px);
    }
  }

  &__image-text {
    font-weight: 600;
    font-size: toRem(11px);
    line-height: toRem(9.87px);
    color: color('color-03');
    margin-top: toRem(13px);
    margin-left: 10%;

    @include bp(m) {
      margin-top: toRem(24px);
      margin-left: 10%;
    }
  }
}
</style>
